'use client';

/**
 * ReferralCaptureLite - Minimal ?ref= capture for non-/auth entry surfaces
 *
 * FIX-F (2026-07-21 auth-hardening audit, referral-affiliate surface, P2 finding
 * "ReferralCapture is the ONLY caller of captureReferralFromURL, mounted ONLY on
 * the /auth route group layout"): a partner sharing the homepage or any
 * (marketing) page (about/blog/features/etc.) instead of a direct /auth/register
 * link had their ?ref= param silently dropped before the visitor ever reached an
 * auth page — `captureReferralFromURL()` runs once, on the auth layout mount, and
 * by then the URL query param is long gone (no ?ref survives an internal nav to
 * /auth/register unless the link explicitly re-appends it).
 *
 * This is deliberately NOT the full `ReferralCapture` component: it skips the
 * `/api/referrals/track-click` analytics fetch (that stays owned by the /auth
 * mount, the actual conversion-funnel entry point) and only performs the
 * cookie/localStorage capture via `captureReferralFromURL()` — same underlying
 * write, no extra network call, renders nothing. Natural double-capture guard:
 * `captureReferralFromURL()` strips `?ref=` from the URL on first call, so if a
 * visitor later lands on /auth/register without a fresh `?ref=` in the URL, the
 * auth layout's `ReferralCapture` mount is a no-op there.
 */

import { useEffect } from 'react';
import { captureReferralFromURL } from '../utils/referral-link';

export function ReferralCaptureLite() {
  useEffect(() => {
    captureReferralFromURL();
  }, []);

  // Renders nothing - capture-only, no UI weight.
  return null;
}
